import React from 'react';
import ReactDOM from 'react-dom';
import authProvider from '../../core/AuthenticationProvider';
import masterService from '../../core/services/Common/MasterService';
import userSettingService from '../../core/services/Common/UserSettingService';
import { setSyncState } from '../app/commonReducer';
import {
  getSyncComponentSearch,
  getSyncComponentState,
} from '../helpers/Common';
import store from '../app/store';
import { Provider } from 'react-redux';
import GoldenLayout from 'golden-layout';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import 'golden-layout/src/css/goldenlayout-base.css';
import 'golden-layout/src/css/goldenlayout-dark-theme.css';
import EventEmitter, { LOAD_WORKSPACE } from '../helpers/EventEmitter';
import LayoutHelper from '../helpers/Layout';
import {
  calendar,
  layoutDefault,
  nameSaveStateDefault,
} from '../../configs/LayoutConfig';
import Const from '../main-layout/sidebar/Const';
import {
  fetchDataWorkspace,
  fetchInitDataWorkspace,
} from '../main-layout/sidebar/reducer';
import widgetConfig from './../../configs/WidgetConfig';
import CommonConst from './Const';
import {
  checkIsBank,
  formatComGroupCode,
  getMinSizeComponent,
  getUnique,
  isOpenSpecificComponent,
} from './../helpers/Common';
import {
  changeCountComponent,
  REDUCER_NAME as COMMON_REDUCER_NAME,
} from './../app/commonReducer';
import { toggleIntro } from '../app/reducer';
import currentState from './../helpers/CurrentState';
import registerCancelTokenAxios from '../helpers/RegisterCancelTokenAxios';
import SyncComponent from './sync-component/SyncComponent';

export const COMPONENT_RESIZE = 'COMPONENT_RESIZE';
export const LAYOUT_TAB_CREATED = 'LAYOUT_TAB_CREATED';
export const LAYOUT_STACK_CREATED = 'LAYOUT_STACK_CREATED';
export const LAYOUT_ITEM_DESTROYED = 'LAYOUT_ITEM_DESTROYED';
export const COMPONENT_DRAG = 'COMPONENT_DRAG';

const getAllComponent = root => {
  if (!root || !root.contentItems) {
    return [];
  }
  return root.contentItems.reduce((result, item) => {
    if (item.componentName) {
      return result.concat(item);
    }

    return result.concat(getAllComponent(item));
  }, []);
};

const getStackMaximized = root => {
  let stack = null;
  const findStackMaximized = root => {
    if (stack) {
      return stack;
    }
    if (!root.contentItems) {
      return stack;
    }
    root.contentItems.forEach(item => {
      if (item.config.type === 'stack' && item.isMaximised) {
        stack = item;
        return;
      }

      stack = findStackMaximized(item);
    });

    return stack;
  };

  return findStackMaximized(root);
};

class GoldenLayoutWrapper extends React.Component {
  hasDeleteCurrentState = true;

  changeTitleMaximiseMinimise = controlsContainer => {
    setTimeout(() => {
      const maximise = controlsContainer.find('.lm_maximise')[0];
      if (!maximise) {
        return;
      }
      if (maximise && maximise.getAttribute('title') === 'maximise') {
        maximise.setAttribute('title', I18n.t('common.maximise'));
      } else {
        maximise.setAttribute('title', I18n.t('common.minimise'));
      }
    }, 0);
  };

  popoutEvent = () => {
    this.hasDeleteCurrentState = false;
    const stateFromStorage =
      JSON.parse(LayoutHelper.getState(nameSaveStateDefault)) || {};
    stateFromStorage.data = currentState.getAll();

    LayoutHelper.saveState(
      nameSaveStateDefault,
      JSON.stringify(stateFromStorage),
    );
  };

  changeTitlePopout = popoutClass => {
    const popout = popoutClass[0];
    popout && popout.setAttribute('title', I18n.t('common.popout'));
  };

  changeTitleHeaderControls = header => {
    const { controlsContainer = {} } = header || {};

    controlsContainer.find('.lm_maximise').click(() => {
      this.changeTitleMaximiseMinimise(controlsContainer);
    });

    this.changeTitleMaximiseMinimise(controlsContainer);

    const popoutClass = controlsContainer.find('.lm_popout');
    if (popoutClass) {
      popoutClass.click(this.popoutEvent);
      this.changeTitlePopout(popoutClass);
    }
  };

  componentDidMount() {
    this.initGoldenLayout();
    this.applyStateFromServer();
    EventEmitter.subscribe(LOAD_WORKSPACE, this.onLoadWorkspace);
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe(LOAD_WORKSPACE, this.onLoadWorkspace);
  }

  getHashParams = () => {
    const params = window.location.hash.replace('#', '');

    return new URLSearchParams(params);
  };

  setInitComponent = () => {
    try {
      const { listOrganizationByTicker } = this.props;
      if (!this.layout.root) {
        return;
      }
      const params = this.getHashParams();
      const listComponentTitle = I18n.t('common.listComponent');
      const ticker = listOrganizationByTicker[params.get('t')];
      const dragCode = ticker ? ticker : null;
      const componentName = params.get('c');
      const config = {
        title: listComponentTitle[componentName],
        name: componentName,
        tooltip: listComponentTitle[componentName],
        type: 'react-component',
        component: componentName,
        props: { dragCode },
      };
      setTimeout(() => {
        this.layout.root.addChild(config);
      }, 0);
    } catch (e) {}
  };

  onLoadWorkspace = () => {
    setTimeout(() => {
      this.changeComponentTitle();
    }, 0);
  };

  getCurrentWorkSpace = async user => {
    const { fetchDataWorkspace } = this.props;
    if (!user) {
      return masterService.getGuestWorkSpace().then(res => res.items);
    }
    return fetchDataWorkspace({
      Name: Const.CURRENT_WORKSPACE_NAME,
      IncludeThumbnail: false,
    });
  };

  getWorkSpace = async name => {
    return userSettingService.getWorkspace({ name }).then(res => res.items);
  };

  applyStateFromServer = async () => {
    const isPopup = window.opener && window.opener !== window;
    const savedState = LayoutHelper.getState(nameSaveStateDefault);
    const { props, name } = this.props;

    const user = await authProvider.getUser();
    if (!user && savedState) {
      const glState = JSON.parse(savedState);
      if (!glState) {
        return;
      }
      currentState.apply(glState.data || {});
      if (!isPopup) {
        LayoutHelper.reload(glState);
      }
      return;
    }

    const currentWorkSpace = await this.getWorkSpace(name);
    if (
      !currentWorkSpace ||
      !Array.isArray(currentWorkSpace) ||
      !currentWorkSpace[0]
    ) {
      return;
    }

    const glState = JSON.parse(
      currentWorkSpace[0].workspace || currentWorkSpace[0].workSpace,
    );
    if (!glState) {
      return;
    }

    currentState.apply(glState.data || {});
    if (!isPopup) {
      LayoutHelper.reload(glState);
      const { setSyncState } = this.props;
      const payload = {
        syncComponent: getSyncComponentState(),
        syncComponentSearch: getSyncComponentSearch(),
      };
      setSyncState(payload);
    }
  };

  initGoldenLayout = () => {
    const { minItemWidth, minItemHeight } = getMinSizeComponent();
    this.layout = new GoldenLayout(
      {
        ...layoutDefault,
        minItemWidth,
        minItemHeight,
      },
      this.layoutRef,
    );

    this.layout.init();
    LayoutHelper.set(this.layout, this.context.store);
    window.addEventListener('resize', () => {
      if (this.layout) {
        this.layout.updateSize();
      }
    });

    this.layout.on('componentCreated', component => {
      const maximized = getStackMaximized(this.layout.root);
      if (maximized && typeof maximized.toggleMaximise === 'function') {
        maximized.toggleMaximise();
      }
      component.config.title = I18n.t(
        `common.listComponent.${component.config.component}`,
      );
      const id =
        component.config.props && component.config.props.id
          ? component.config.props.id
          : getUnique();
      const componentName =
        component && component.config && component.config.component;
      const dragCode =
        component.config.props && component.config.props.dragCode
          ? component.config.props.dragCode
          : null;
      component.config.props = {
        id,
        componentName,
        ...component.config.props,
      };
      this.changeCountComponent(component, 1);

      if (componentName && id) {
        this.dispatch(
          componentName,
          {
            id,
            dragCode,
          },
          'INIT_COMPONENT',
        );
      }
      this.dispatchChangeSizeComponent(component, id);

      component.container.on('resize', () => {
        this.dispatchChangeSizeComponent(component, id);

        const componentName = component.config.component;
        this.dispatchEvent(COMPONENT_RESIZE, componentName);
      });
    });

    this.layout.on('tabCreated', tab => {
      this.renderSyncComponentLink(tab);
      const componentName = tab.contentItem.config.component;
      this.dispatchEvent(LAYOUT_TAB_CREATED, componentName);

      tab._dragListener.on('drag', () => {
        const componentName = tab.contentItem.config.component;
        const componentId = tab.contentItem.config.props.id;
        this.dispatchEvent(
          COMPONENT_DRAG,
          [componentName, componentId].join(''),
        );
      });
    });

    this.layout.on('stackCreated', stack => {
      this.changeTitleHeaderControls(stack.header);
      this.dispatchEvent(LAYOUT_STACK_CREATED);
      this.limitDropComponent(stack, minItemWidth, minItemHeight);
      this.changeZIndexWhenMaximum(stack);
      this.removeMaximizedWhenPopout(stack);
      stack.header.controlsContainer.find('.lm_popout').hide();
    });

    this.layout.on('itemDestroyed', item => {
      this.changeCountComponent(item, -1);
      const componentName = item && item.config && item.config.component;
      const componentId =
        item && item.config && item.config.props && item.config.props.id;

      if (componentName && componentId) {
        setTimeout(() => {
          if (this.hasDeleteCurrentState) {
            currentState.delete(componentName, componentId);
          } else {
            this.hasDeleteCurrentState = true;
          }
        }, 0);

        registerCancelTokenAxios.delete(componentName);
        registerCancelTokenAxios.delete(componentName + componentId);
        this.dispatch(componentName, { id: componentId }, 'UNMOUNT_COMPONENT');
      }

      this.dispatchEvent(LAYOUT_ITEM_DESTROYED);
    });
  };

  renderSyncComponentLink = tab => {
    const enableComponents = [
      // CommonConst.listComponent.Watchlist,
      // CommonConst.listComponent.TopBreakout,
      // CommonConst.listComponent.TopForeignTrade,
      // CommonConst.listComponent.TopGainers,
      // CommonConst.listComponent.TopLosers,
      // CommonConst.listComponent.TopNewHigh,
      // CommonConst.listComponent.TopNewLow,
      // CommonConst.listComponent.TopValue,
      // CommonConst.listComponent.TopVolume,
      // CommonConst.listComponent.MarketCalendar,
      // CommonConst.listComponent.TimeAndSales,
      // CommonConst.listComponent.PriceDepth,
      // CommonConst.listComponent.PriceData,
      // CommonConst.listComponent.Charting,
      CommonConst.listComponent.FASnapshot,
      // CommonConst.listComponent.Ownership,
      // CommonConst.listComponent.FinancialAnalysis,
      CommonConst.listComponent.FADividendAnalysis,
      //CommonConst.listComponent.ConsensusAnalysis,
      CommonConst.listComponent.FinancialStatement,
      // CommonConst.listComponent.Valuation,
      // CommonConst.listComponent.STRanking,
      // CommonConst.listComponent.Screener,
      // CommonConst.listComponent.Strategy,
      CommonConst.listComponent.FinancialRatio,
      // CommonConst.listComponent.Alerts,
      // CommonConst.listComponent.TASignals,
      // CommonConst.listComponent.News,
    ];
    const componentName = tab.contentItem.config.component;
    if (!enableComponents.includes(componentName)) {
      return;
    }

    const div = document.createElement('div');
    const componentId = tab.contentItem.config.props.id;
    div.className = 'sync-component-icon';
    div.title = I18n.t('layout.syncComponent');
    tab.element[0].prepend(div);
    tab.element[0].style.paddingLeft = '20px';
    ReactDOM.render(
      <Provider store={store}>
        <SyncComponent
          componentId={componentId}
          componentName={componentName}
        />
      </Provider>,
      div,
    );
  };

  dispatchEvent = (eventName, componentKey = null) => {
    const event = new CustomEvent(eventName, {
      detail: componentKey,
    });
    window.dispatchEvent(event);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { locale, listOrganizationByTicker } = this.props;
    if (locale !== prevProps.locale || locale !== 'vi') {
      this.changeComponentTitle();
    }

    if (
      !Object.keys(prevProps.listOrganizationByTicker).length &&
      Object.keys(listOrganizationByTicker).length &&
      isOpenSpecificComponent()
    ) {
      this.setInitComponent();
    }
  }

  removeMaximizedWhenPopout = stack => {
    const popoutEl = stack.header.controlsContainer.find('.lm_popout')[0];
    const clonePopout = popoutEl.cloneNode();
    clonePopout.addEventListener('click', () => {
      if (stack.isMaximised) {
        stack.toggleMaximise();
      }
      setTimeout(() => {
        popoutEl.click();
      }, 0);
    });
    popoutEl.parentNode.prepend(clonePopout);
    popoutEl.style.display = 'none';
  };

  getGlState = savedState => {
    const glState = JSON.parse(savedState);
    const changeComponentTitle = state => {
      if (!state.content) {
        return;
      }

      state.content.forEach(item => {
        if (item.component) {
          item.title = I18n.t(`common.listComponent.${item.component}`);
          return;
        }

        changeComponentTitle(item);
      });
    };
    changeComponentTitle(glState);

    return glState;
  };

  changeComponentTitle = () => {
    getAllComponent(LayoutHelper.layout.root).forEach(component => {
      this.changeTitleHeaderControls(component.parent.header);
      component.setTitle(
        I18n.t(`common.listComponent.${component.config.component}`),
      );
    });
  };

  dispatch(componentName, payload, type) {
    widgetConfig.forEach(({ list }) => {
      list.forEach(({ listReducer, name }) => {
        if (componentName === name) {
          listReducer &&
            listReducer.forEach(item => {
              this.context.store.dispatch({
                type: `${item}${type}`,
                payload,
              });
            });
        }
      });
    });
  }

  changeCountComponent = (component, count) => {
    const componentName = component.config.component;
    componentName &&
      this.context.store.dispatch(changeCountComponent(componentName, count));
  };

  toggleIntro = status => {
    this.context.store.dispatch(toggleIntro(status));
  };

  dispatchChangeSizeComponent = (component, id) => {
    const { width, height } = component.container;
    const componentName = component.config.component;
    try {
      if (width < calendar.minWidth) {
        component.container._element.addClass(calendar.className);
      } else {
        component.container._element.removeClass(calendar.className);
      }
    } catch (e) {}

    this.dispatch(
      componentName,
      { width, height, id },
      'CHANGE_SIZE_COMPONENT',
    );
  };

  limitDropComponent = (e, minItemWidth, minItemHeight) => {
    e._$highlightDropZone = function(x, y, areaSurface) {
      var segment, area;

      for (segment in this._contentAreaDimensions) {
        area = this._contentAreaDimensions[segment].hoverArea;
        const highlightArea = this._contentAreaDimensions[segment]
          .highlightArea;

        if (area.x1 < x && area.x2 > x && area.y1 < y && area.y2 > y) {
          if (segment === 'header') {
            this._dropSegment = 'header';
            this._highlightHeaderDropZone(this._sided ? y : x);
          } else {
            if (
              highlightArea.x2 - highlightArea.x1 < minItemWidth ||
              highlightArea.y2 - highlightArea.y1 < minItemHeight
            ) {
              this._dropSegment = 'header';
              return;
            }
            this._resetHeaderDropZone();
            this._highlightBodyDropZone(segment);
          }

          return;
        }
      }
    };
  };

  changeZIndexWhenMaximum = stack => {
    stack.header.controlsContainer
      .find('.lm_maximise') //get the maximise icon
      .click(function() {
        //Get maximise and minimise events here
        const Z_INDEX = 1000;
        if (parseInt(stack.element[0].style.zIndex) !== Z_INDEX) {
          stack.element[0].style.zIndex = Z_INDEX;
        } else {
          stack.element[0].style.zIndex = null;
        }
      });
  };

  render() {
    return (
      <div
        id="goldenLayout"
        className="goldenLayout"
        ref={input => (this.layoutRef = input)}
      />
    );
  }
}

GoldenLayoutWrapper.contextTypes = {
  store: PropTypes.object.isRequired,
  locale: PropTypes.string,
};

const mapStateToProps = state => ({
  locale: state.i18n.locale,
  listOrganizationByTicker: state[COMMON_REDUCER_NAME].listOrganizationByTicker,
});

const mapDispatchToProps = {
  fetchInitDataWorkspace,
  setSyncState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GoldenLayoutWrapper);
